// extracted by mini-css-extract-plugin
export default {"placeholder":"image_placeholder__379b_","feature":"image_feature__35xFt","square":"image_square__2P0a6","poster":"image_poster__IyBmI","standard":"image_standard__3_m5C"};